/** App in 'development' environment */
export const IS_DEV = process.env.NODE_ENV === 'development';

export const TIMEZONE = process.env.NEXT_PUBLIC_TIMEZONE ?? 'Australia/Melbourne';
export const LOCALE = process.env.NEXT_PUBLIC_LOCALE ?? 'en-AU';
export const ENTRIES_PER_PAGE = 12;

export const SEPARATOR = `•`;

export enum IMG_RATIO {
  SQUARE = 1,
  PORTRAIT = 1.2,
  LANDSCAPE = 496 / 744,
  LANDSCAPE_TALL = 0.8,
  LANDSCAPE_WIDE = 0.54,
  VIDEO = 0.5625,
}

export type ImgRatios = typeof IMG_RATIO;
export type ImgRatio = keyof ImgRatios;
